var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prebuy"},[_vm._v("\n  "+_vm._s(_vm.dateFormater(_vm.time, 'MM-dd hh:mm'))+" 尾款期结束 "),_c('span',[_vm._v("付尾款 ￥"+_vm._s(_vm.price))])])}
var staticRenderFns = []

export { render, staticRenderFns }